import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
    selector: 'save-filter-list-link',
    templateUrl: './save-filter-list-link.component.html',
    styleUrls: ['./save-filter-list-link.component.scss'],
    standalone: false
})



export class SaveFilterListLinkComponent implements OnInit {

  @Output() showFilterRecallPanel = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {}

  showTheFilterRecallPanel() {
    this.showFilterRecallPanel.emit();
  }
}
